import React from "react";
import Box from "@mui/material/Box";
import Autocomplete from "@mui/material/Autocomplete";
import {AutocompleteTextFieldStyled, PaperStyled} from "../../../shared/form/AutocompleteAPI";
import CircularProgress from "@mui/material/CircularProgress";
import {getRomanNumber} from "../../../utils/functions";
import {IClassroom, IClassroomOption} from "../../../shared/types/Classroom";

interface AddClassroomsDialogProps {
    classrooms: IClassroomOption[];
    selectedClassrooms: IClassroomOption[];
    loading?: boolean;
    onChange: (classrooms: IClassroomOption[]) => void;
}
const AddClassroomsDialog = ({
    classrooms,
    selectedClassrooms,
    loading = false,
    onChange,
}: AddClassroomsDialogProps) => {

    const availableClassrooms = classrooms.filter(
        (classroom) =>
            !selectedClassrooms.some(
                (selectedClassroom) => selectedClassroom.id === classroom.id,
            ),
    );

    const handleOptionSelect = (
        _event: React.SyntheticEvent,
        newValue: IClassroomOption | null,
    ) => {
        if (!newValue) {
            return;
        }

        if (
            selectedClassrooms.some(
                (classroom) => classroom.id === newValue.id,
            )
        ) {
            return;
        }

        onChange([...selectedClassrooms, newValue]);
    };

    return (
        <Box sx={{border: "1px solid #ddd", borderRadius: "16px"}}>
            <Autocomplete<IClassroomOption, false, false, false>
                options={availableClassrooms}
                loading={loading}
                blurOnSelect
                noOptionsText="Nu sunt rezultate"
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                }
                PaperComponent={PaperStyled}
                onChange={handleOptionSelect}
                renderOption={(props, option) => (
                    <li {...props} key={option.id}>
                        {option.label}
                    </li>
                )}
                renderInput={(params) => (
                    <AutocompleteTextFieldStyled
                        {...params}
                        label="Alege clasa"
                        variant="filled"
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                    {loading && (
                                        <CircularProgress
                                            color="inherit"
                                            size={20}
                                        />
                                    )}
                                    {params.InputProps.endAdornment}
                                </>
                            ),
                        }}
                    />
                )}
            />
        </Box>
    );
};

export const toClassroomOption = (
    classroom: IClassroom,
): IClassroomOption => ({
    ...classroom,
    label: `(${getRomanNumber(classroom.grade)}) ${classroom.name}`,
    value: classroom.id,
});

export default AddClassroomsDialog;